<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "AddCustomer" });
</script>
<template>
  <div class="subcribeheadall">
    <div class="subscribeTop">
      <el-breadcrumb :separator-icon="ArrowRight">
        <el-breadcrumb-item class="subscri_size1" :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="subscri_size2" >预约使用</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="subcribehead">
      <div class="add-custom">
        <!-- <slot> -->
        <!-- 页面头部背景 -->
        <!-- </slot> -->
        <h1 class="head">
          cognerry，助力企业打造专属、安全、高效的数字化管理协作平台
        </h1>
        <el-form
          ref="applyInfoFormRef"
          :model="applyInfoData"
          size="default"
          :rules="menuFormRules"
          label-position="right"
          :inline="true"
          style="line-height: 50px;"
          label-height="3.7639rem"
        >
          <el-form-item label="姓名" prop="name" height="20px" label-height="3.7639rem">
            <!-- <template #label>
          <div class="apply-from-label">姓名</div>
        </template> -->
            <el-input
              v-model="applyInfoData.name"
              class="inputItem"
              :validate-event="false"
              placeholder="请输入"
              style="height:45px"
            />
          </el-form-item>
          <el-form-item label="手机号码" prop="phoneNo" >
            <!-- <template #label>
          <div class="apply-from-label">手机号码</div>
        </template> -->
            <el-input
              v-model="applyInfoData.phoneNo"
              :validate-event="false"
              class="inputItem"
              placeholder="请输入"
              style="height:45px"
            />
          </el-form-item>
          <el-form-item label="组织名称" prop="orgName">
            <!-- <template #label>
          <div class="apply-from-label">组织名称</div>
        </template> -->
            <el-input
              v-model="applyInfoData.orgName"
              :validate-event="false"
              class="inputItem"
              placeholder="请输入"
              style="height:45px"
            />
          </el-form-item>
          <el-form-item label="职务" prop="dutyName">
            <!-- <template #label>
          <div class="apply-from-label">职务</div>
        </template> -->
            <el-input
              v-model="applyInfoData.dutyName"
              :validate-event="false"
              class="inputItem"
              placeholder="请输入"
              style="height:45px"
            />
          </el-form-item>
          <el-form-item label="使用场景" prop="demandSituation">
            <!-- <template #label>
          <div class="apply-from-label">使用场景</div>
        </template> -->
            <el-input
              v-model="applyInfoData.demandSituation"
              class="inputItem"
              :validate-event="false"
              placeholder="请输入您使用移动平台的场景或目的"
              style="height:45px"
            />
          </el-form-item>
          <el-form-item label="所在地区" prop="area">
            <!-- <template #label>
          <div class="apply-from-label">所在地区</div>
        </template> -->
            <el-input
              v-model="applyInfoData.area"
              :validate-event="false"
              class="inputItem"
              placeholder="请输入您所在地区"
              style="height:45px"
            />
          </el-form-item>
        </el-form>
        <button
            class="submit-btn"
            type="button"
            :loading="loading"
            @click="submitUserFrom"
          >
            免费试用
          </button>
          <div class="readerText">点击免费试用，代表你已阅读并同意《cognerry服务协议》和《cognerry隐私政策》</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
;
import { ref, reactive } from "vue";
import { debounce } from "lodash";
import { FormInstance, ElMessage } from "element-plus";
import { useCustomerStore } from "@/stores/applyUse";
import { ArrowRight } from "@element-plus/icons-vue";
interface applyInfoItem {
  name: string;
  phoneNo: string;
  orgName: string;
  dutyName: string;
  demandSituation: string;
  area: string;
}
const validateMobile = (
  rule: unknown,
  value: string,
  callback: (arg?: Error) => void
) => {
  if (!isNaN(Number(value)) && value.length === 11) {
    callback();
  }
  callback(new Error("请输入正确格式手机号!"));
};
const menuFormRules = reactive({
  name: {
    required: true,
    message: "请输入您的姓名",
    trigger: "change",
  },
  phoneNo: [
    {
      required: true,
      message: "请输入您的手机号码",
      trigger: "change",
    },
    {
      message: "请输入正确11位手机号",
      trigger: "change",
      validator: validateMobile,
    },
  ],
  orgName: {
    // required: true,
    message: "请输入您的组织名称",
    trigger: "change",
  },
  dutyName: {
    // required: true,
    message: "请输入您的职务",
    trigger: "change",
  },
  demandSituation: {
    // required: true,
    message: "请输入您使用移动平台场景",
    trigger: "change",
  },
  area: {
    required: true,
    message: "请输入您所在的地区",
    trigger: "change",
  },
});
const applyInfoData = reactive<applyInfoItem>({
  name: "",
  phoneNo: "",
  orgName: "",
  dutyName: "",
  demandSituation: "",
  area: "",
});
const resetForm = () => {
  loading.value = false;
  applyInfoFormRef.value?.resetFields();
  applyInfoData.name = "";
  applyInfoData.phoneNo = "";
  applyInfoData.orgName = "";
  applyInfoData.dutyName = "";
  applyInfoData.demandSituation = "";
  applyInfoData.area = "";
};
const store = useCustomerStore();
const loading = ref(false);
const applyInfoFormRef = ref<FormInstance | null>(null);
const submitUserFrom = debounce(() => {
  (applyInfoFormRef.value as FormInstance).validate((valid) => {
    if (valid) {
      loading.value = true;
      addNewRole({ ...applyInfoData });
    }
  });
}, 600);
const $emit = defineEmits(["closeApplyDailog"]);
const addNewRole = async (data: applyInfoItem) => {
  store
    .addCustomer({ ...data })
    .then((res) => {
      // if(res.status == 10000000){
      //   $emit('closeApplyDailog')
      // }
      if (res.status == 0) {
        ElMessage({
          message: "信息提交成功,我们将尽快与您联系！",
          type: "success",
        });
        resetForm();
        // 提交表单成功关闭首页弹框
        $emit("closeApplyDailog");
      }
    })
    .catch(() => {
      loading.value = false;
    });
};
</script>
<style lang="scss" scoped>
.subcribeheadall {
  // 背景图
  background: url("../../../assets/banner/bg_reservation.png") center center /
    cover no-repeat;
  .subscribeTop {
    padding-top: 0.6rem;
    margin-left: 0.8rem;
    .subscri_size1{
      font-size: 18px;
    }
    .subscri_size2{
      font-size: 18px;
      color:#1978F0;
      // background:red;
    }
  }
}
.subcribehead {
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.add-custom {
  width: 100%;
  height: 4.4306rem;
  // overflow-y: auto;
  margin-top: 0.6rem;
  width: 50%; /* 或具体的宽度 */
  margin-left: auto;
  margin-right: auto;
  display: block; /* 确保是块级元素 */

  &::-webkit-scrollbar {
    width: 0px;
  }
  .head {
    font-size: 0.17rem;
    color: #444444;
    margin-bottom: 0.2rem;
    //   width: 50%; /* 或具体的宽度 */
    // margin-left: auto;
    // margin-right: auto;
    // display: block; /* 确保是块级元素 */
  }
  :deep(.el-form-item) {
    margin-left: 0 !important;
  }
  .submit-btn {
    display: block;
    width: 2.75rem;
    height: 0.28rem;
    background: #1978f0;
    border-radius: 0.0417rem;
    font-size: 0.13rem;
    color: #ffffff;
    font-weight: 500;
    // margin: 0 auto;
    margin-left:1rem;
    border: none;
    margin-top: 0.1042rem;
    font-family: PingFangSC-Medium;
  }
  .inputItem {
    width: 2.7778rem;
  }
  :deep(.el-form-item--large) {
    margin-bottom: 0;
  }
  :deep(.el-form-item) {
    margin-bottom: 0.0694rem;
    margin-left: 0.2778rem;
  }
  .readerText {
    text-align: center;
    font-size: 0.08rem;
    color: #a1a1a1;
    margin-top: 0.09rem;
    margin-bottom: 0.1042rem;
    // padding-bottom: .0694rem;
    margin-left:-0.17rem;
    font-weight: 400;
  }
}


//  @media screen and (max-width: 480px) {
//   .add-custom{
//    height: 4.1667rem;
//    margin-left: .1389rem;
//   }

// }
@media screen and (max-width: 480px) {
  :deep(.el-form) {
    padding-right: 0.6944rem;
  }
  .submit-btn {
    // margin-left: 70px !important;
  }
  .readerText {
  }
  .add-custom {
    //  height: 8.9rem !important;
    width: 7.0833rem;
    .submit-btn {
      height: 0.7167rem;
      width: 4.1667rem !important;
      margin-left: 1.3889rem !important;
      margin-top: 0.2778rem;
    }
    .inputItem {
      width: 4rem !important;
      // el-form-item__label
    }
    .readerText {
      margin-top: 0.2389rem;
      font-size: 0.1667rem;
      // margin-left: 0.4167rem;
    }
    :deep(.el-form-item) {
      margin-bottom: 0.15rem;
    }
    :deep(.el-form-item__label) {
      width: 1.7361rem !important;
      //  font-size: 80px;
    }
    ::v-deep .el-input__inner::placeholder {
      // font-size: .2083rem;
    }
  }
}
@media screen and (max-width: 1200px) and (min-width: 480px) {
  .add-custom {
    //  height: 4.1667rem;
    //  margin-left: .1389rem;
  }
  :deep(.el-form-item__label) {
    width: 1.25rem !important;
    //  font-size: 80px;
  }
  :deep(.el-form) {
    padding-right: 0.4167rem;
  }
  .submit-btn {
    // margin-left: 70px !important;
  }
  .readerText {
    // margin-left: 0.3472rem;
  }
}
@media screen and (min-width: 1000px) {
  .submit-btn {
    // margin-left: 70px !important;
  }
  .readerText {
    // margin-left: 0.2778rem;
  }
  :deep(.el-form-item__label) {
    // width: 1.0417rem;//180px
    width: 0.9528rem !important;
  }
}


</style>
<style lang="scss">
::v-deep {
	.demo-ruleForm {
		.el-form-item.is-error {
	      margin-bottom: 30px;
	    }
	}
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFangSC-Regular;
  font-size: 0.0972rem;
  color: #000000;
  opacity: 0.25;
  font-weight: 400;
}
:deep(.el-form-item__label) {
  //  justify-content: center;
  padding: 0 0.1736rem 0 0 !important;
  //  padding-left: .1389rem;
  font-size: 0.0972rem !important;
}
:deep(.el-form-item__error) {
  padding-top: 0;
  top: 92%;
}
:deep(.el-form) {
  padding-right: 0.2083rem;
}
</style>
